var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "addMember" },
    [
      _c(
        "el-dialog",
        {
          staticClass: "welcomeDia treeDia",
          staticStyle: { "'margin-top": "15vh" },
          attrs: {
            title: _vm.title,
            visible: _vm.show,
            "modal-append-to-body": false,
            width: "700px",
            height: "500px",
            "close-on-click-modal": false
          },
          on: {
            "update:visible": function($event) {
              _vm.show = $event
            },
            close: _vm.closeTree
          }
        },
        [
          _c("div", { staticClass: "head-wrap" }, [
            _c(
              "div",
              { staticClass: "head-left" },
              [
                _c("el-input", {
                  staticClass: "search-input",
                  attrs: {
                    placeholder: "搜索成员或部门",
                    "suffix-icon": "el-icon-search",
                    size: "mini",
                    clearable: ""
                  },
                  on: { input: _vm.searchFn, clear: _vm.searchFnClear },
                  model: {
                    value: _vm.formInline.usageScenario,
                    callback: function($$v) {
                      _vm.$set(_vm.formInline, "usageScenario", $$v)
                    },
                    expression: "formInline.usageScenario"
                  }
                })
              ],
              1
            ),
            _c("div", { staticClass: "head-right" }, [
              _c("span", { staticClass: "selected-title" }, [
                _vm._v("已选成员")
              ])
            ])
          ]),
          _c("div", { staticClass: "data-wrap" }, [
            _c(
              "div",
              { staticClass: "tree-wrap" },
              [
                _c("el-tree", {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.serarchState,
                      expression: "serarchState"
                    }
                  ],
                  ref: "codeTree",
                  staticClass: "tree filter-tree",
                  staticStyle: { height: "100%" },
                  attrs: {
                    "check-strictly": "",
                    data: _vm.treeData,
                    "node-key": "id",
                    "show-checkbox": "",
                    "default-expanded-keys": _vm.defaultShowNodes,
                    "default-checked-keys": _vm.defaultCheckedKeys,
                    "expand-on-click-node": false,
                    "current-node-key": _vm.currentNodeKey,
                    "highlight-current": true,
                    "check-on-click-node": true,
                    props: _vm.defaultProps
                  },
                  on: { "check-change": _vm.nodeClick, check: _vm.checkHandle },
                  scopedSlots: _vm._u([
                    {
                      key: "default",
                      fn: function(ref) {
                        var node = ref.node
                        var data = ref.data
                        return _c("span", { staticClass: "custom-tree-node" }, [
                          _c(
                            "span",
                            {
                              attrs: {
                                title: data.hasChildren
                                  ? data.departmentName
                                  : data.userName
                              }
                            },
                            [
                              _vm._v(
                                "  " +
                                  _vm._s(
                                    data.hasChildren
                                      ? data.departmentName
                                      : data.userName
                                  )
                              )
                            ]
                          )
                        ])
                      }
                    }
                  ])
                }),
                _c(
                  "div",
                  {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value: !_vm.serarchState,
                        expression: "!serarchState"
                      }
                    ],
                    staticClass: "ww_searchResult"
                  },
                  [
                    _vm.searchStaff.length !== 0
                      ? _c("div", { staticClass: "search-title" }, [
                          _vm._v("人员")
                        ])
                      : _vm._e(),
                    _c(
                      "ul",
                      { staticClass: "search-data-wrap" },
                      _vm._l(_vm.searchStaff, function(item, index) {
                        return _c(
                          "li",
                          {
                            key: index,
                            style: index == 0 ? "background:#0C4C7F" : "",
                            on: {
                              click: function($event) {
                                return _vm.clickSearchSelect(index, item)
                              }
                            }
                          },
                          [
                            _c(
                              "a",
                              {
                                staticClass: "ww_searchResult_itemTxt",
                                style: index == 0 ? "color:#FFF" : "",
                                attrs: { href: "javascript:;" }
                              },
                              [
                                _c(
                                  "span",
                                  {
                                    staticClass:
                                      "ww_searchResult_title_peopleName",
                                    attrs: { title: item.userName }
                                  },
                                  [_vm._v(_vm._s(item.userName))]
                                ),
                                _c(
                                  "span",
                                  {
                                    staticClass:
                                      "ww_searchResult_title_peopleDepartment",
                                    attrs: { title: item.departmentName }
                                  },
                                  [_vm._v(_vm._s(item.departmentName))]
                                )
                              ]
                            )
                          ]
                        )
                      }),
                      0
                    ),
                    _vm.searchDepart.length !== 0
                      ? _c("div", { staticClass: "search-title" }, [
                          _vm._v(" 部门 ")
                        ])
                      : _vm._e(),
                    _c(
                      "ul",
                      { staticClass: "search-data-wrap" },
                      _vm._l(_vm.searchDepart, function(item, index) {
                        return _c(
                          "li",
                          {
                            key: index,
                            style:
                              _vm.searchStaff.length === 0 && index == 0
                                ? "background:#0C4C7F"
                                : "",
                            on: {
                              click: function($event) {
                                return _vm.clickSearchSelect(index, item)
                              }
                            }
                          },
                          [
                            _c(
                              "a",
                              {
                                staticClass: "ww_searchResult_itemTxt",
                                style:
                                  _vm.searchStaff.length === 0 && index == 0
                                    ? "color:#FFF"
                                    : "",
                                attrs: { href: "javascript:;" }
                              },
                              [
                                _c(
                                  "span",
                                  {
                                    staticClass:
                                      "ww_searchResult_title_peopleName"
                                  },
                                  [_vm._v(_vm._s(item.departmentName))]
                                )
                              ]
                            )
                          ]
                        )
                      }),
                      0
                    )
                  ]
                )
              ],
              1
            ),
            _c(
              "div",
              { staticClass: "selected-wrap", attrs: { id: "selectedWrap" } },
              _vm._l(_vm.currentIdName, function(item, index) {
                return _c("div", { key: index, staticClass: "select-right" }, [
                  _c(
                    "i",
                    {
                      class:
                        item.type == "depart"
                          ? "el-icon-folder-opened"
                          : "el-icon-user"
                    },
                    [_vm._v(" " + _vm._s(item.name))]
                  ),
                  _c("i", {
                    staticClass: "el-icon-close",
                    on: {
                      click: function($event) {
                        return _vm.clickCurrrntFn(item)
                      }
                    }
                  })
                ])
              }),
              0
            )
          ]),
          _c(
            "div",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer"
            },
            [
              _c(
                "el-button",
                { attrs: { size: "small" }, on: { click: _vm.closeTree } },
                [_vm._v("取 消")]
              ),
              _c(
                "el-button",
                {
                  attrs: { type: "primary", size: "small" },
                  on: { click: _vm.clickSubmit }
                },
                [_vm._v("确 定")]
              )
            ],
            1
          )
        ]
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }